var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.label))]),(_vm.labelRequired)?_c('span',{staticStyle:{"color":"#003366","font-size":"20px"}},[_vm._v("*")]):_vm._e(),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }